<template>
  <div>
    <div v-for="(item,index) in itemArr" :key="index">
      <certification-item :item="item"></certification-item>
    </div>

  </div>
</template>

<script>
import certificationItem from './components/certification-item';

export default {
  name: "UseRaccountNumber",
  components: {
    certificationItem
  },
  data() {
    return {
      itemArr: [
        {
          id:'loginName',
          name: '个人资料',
          desc: '完善个人资料',
          button: '去完善',
          success: false,
          url: '/homeUser/userInfo',
          index: 1
        },
        {
          id: 'idCard',
          name: '重置密码',
          desc: '重置密码',
          button: '重置',
          success: true,
          url: '/homeUser/userRealName',
          index: 2
        },
        {
          id: 'school',
          name: '学习情况',
          desc: '查看-学习情况',
          button: '查看',
          success: false,
          url: '/homeUser/learningSituation',
          index: 3
        }
      ]
    }
  },
  created() {
    this.$get(this.$API.MEMBER_INFO, {}).then(res => {
      if (res.code === 200) {
        this.userInfo = res.data
        if(this.userInfo.idCard) {
          this.itemArr[0].success = true
        }
      }
    })


    this.$get(this.$API.STATISTICS_STUDY_RECORD, {}).then(res => {
      this.tableData.push(res.data)

      if (res.code === 200) {
        if(res.data.totalNum === res.data.completeNum) {
          this.itemArr[2].success = true
        }
      }

    })
  }
}
</script>

<style scoped>

</style>
